if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      this.swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider();
    }

    initSlider() {
      // Guard contra doble-init: shopify:section:load puede volver a llamar
      // esto sobre una instancia que ya se inicializo en el constructor.
      if (this.slider) return;

      this.slider = new Swiper(this, {
        slidesPerView: 1,
        loop: this.swiperOptions.loop || false,
        allowTouchMove: false,
        autoplay: this.swiperOptions.autoplay || false,
      });
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}

// Un solo listener a nivel de modulo (no uno por instancia dentro del
// constructor) -- mismo patron que assets/card-product-slider.js. La version
// anterior registraba un listener nuevo en `window` cada vez que el theme
// editor reconstruia esta seccion, acumulandolos indefinidamente.
document.addEventListener('shopify:section:load', event => {
  const slider = event.target.querySelector('announcement-bar-slider');
  if (slider) slider.initSlider();
});
